<template>
  <div>
    <vs-card>
      <div slot="header">Liste des résultats</div>
      <div>
        <vs-row>
          <vs-col vs-type="flex" vs-w="4" class="pt-2">
            <vs-select
              class="w-full"
              @change="autoCompleteFuncPeriod"
              label="Selectionner une période"
              autocomplete
              v-model="selected"
            >
              <vs-select-item
                :value="item.id"
                :text="
                  item.name +
                  ' (' +
                  item.start_date +
                  ' au ' +
                  item.end_date +
                  ')'
                "
                v-for="(item, index) in periods"
                :key="index"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4" class="pt-2">
            <vs-select
              class="w-full ml-2"
              @change="autoCompleteFunc"
              label="Selectionner une évaluation"
              autocomplete
              v-model="selectedEvaluation"
            >
              <vs-select-item
                :value="item.id"
                :text="item.name"
                v-for="(item, index) in evaluations"
                :key="index"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4" class="pt-2">
            <vs-button
              class="ml-2"
              v-if="selected !== '' && selectedEvaluation !== ''"
              color="primary"
              style="margin-top: 16px"
              @click="exportAllEvalResults()"
              type="border"
              >Exporter</vs-button
            >
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col>
            <vs-table
              ref="table"
              :max-items="itemsPerPage"
              :data="composed"
              pagination
            >
              <div
                v-if="selectedEvaluation !== ''"
                slot="header"
                class="flex flex-wrap-reverse items-center flex-grow justify-between"
              >
                <div class="con-input-search vs-table--search">
                  <input
                    v-model="search"
                    @keypress.enter="autoCompleteFunc"
                    type="text"
                    class="input-search vs-table--search-input"
                  />
                  <i class="vs-icon notranslate icon-scale material-icons null"
                    >search</i
                  >
                </div>
              </div>
              <template slot="thead">
                <vs-th>Date d'évaluation</vs-th>
                <vs-th>Candidats</vs-th>
                <vs-th>Note</vs-th>
                <vs-th>Résulat final</vs-th>
                <vs-th>Action</vs-th>
              </template>
              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td>{{ tr.created_at }}</vs-td>
                    <vs-td>{{
                      tr.user
                        ? tr.user.lastname + " " + tr.user.firstname
                        : "NA"
                    }}</vs-td>
                    <vs-td>{{
                      tr.marks_obtained + "% / " + tr.quizz.required_avg + " %"
                    }}</vs-td>
                    <vs-td>
                      {{ tr.final_result == "1" ? "OUI" : "NON" }}
                    </vs-td>
                    <vs-td>
                      <div class="flex">
                        <vs-button
                          @click="removeEvaluation(tr)"
                          color="danger"
                          class="mr-1"
                          size="small"
                          type="border"
                          >Supprimer</vs-button
                        >
                        <vs-button
                          @click.prevent="exportResult(tr.id)"
                          color="success"
                          class="mr-1"
                          size="small"
                          type="border"
                          >Exporter</vs-button
                        >
                      </div>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { _buildQuery } from "../../../../helpers/buildquery";
export default {
  data: () => ({
    evaluations: [],
    selected: "",
    composed: [],
    periods: [],
    selectedEvaluation: "",
    itemsPerPage: 50,
    search: "",
  }),
  mounted() {
    this.laodPeriod();
  },
  methods: {
    async exportAllEvalResults() {
      try {
        this.$vs.loading();
        let params = {
          period_id: this.selected,
          quizz_id: this.selectedEvaluation,
          search: this.search,
        };
        const response = await this.$http({
          url: "evaluation/export/results" + _buildQuery(params),
          method: "GET",
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "all_resultats.xlsx");
        document.body.appendChild(link);
        link.click();
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    async exportResult(id) {
      try {
        this.$vs.loading();
        const response = await this.$http({
          url: "evaluation/export/result?result=" + id,
          method: "GET",
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "resultats.xlsx");
        document.body.appendChild(link);
        link.click();
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    removeEvaluation(el) {
      if (confirm("Voulez vous supprimer l'évaluation de cet utilisateur ?")) {
        this.$vs.loading();
        this.$http
          .post("/evaluation/remove/quizz/" + el.id)
          .then((response) => {
            let index = this.composed.indexOf(el);
            this.composed.splice(index, 1);
            window.getApp.success("Composition supprimée", {});
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            console.log(error);
          });
      }
    },
    perc(mark, total) {
      return Math.round((mark / total) * 100);
    },
    autoCompleteFunc() {
      this.$vs.loading();
      let params = {
        element: this.search,
      };
      this.$http
        .get(
          "/evaluation/users/result/" +
            this.selectedEvaluation +
            _buildQuery(params)
        )
        .then((response) => {
          this.composed = response.data;
          //this.search = "";
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
    autoCompleteFuncPeriod() {
      if (this.selected != "") {
        this.$vs.loading();
        this.$http
          .get("/evaluations?all_data=1&period_id=" + this.selected)
          .then((response) => {
            this.selectedEvaluation = "";
            this.evaluations = response.data;
            this.$vs.loading.close();
          })
          .catch((error) => {
            console.log(error);
            this.$vs.loading.close();
          });
      }
    },
    laodEvaluation() {},
    laodPeriod() {
      this.$vs.loading();
      this.$http
        .get("/periods")
        .then((response) => {
          this.periods = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
  },
};
</script>